import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEye16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconEye16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13.925 8.576c-.908 1.544-2.815 3.924-5.84 3.924s-4.932-2.38-5.84-3.924a1.12 1.12 0 0 1 0-1.152C3.154 5.88 5.062 3.5 8.086 3.5s4.932 2.38 5.84 3.924c.212.361.212.791 0 1.152m-12.541.506a2.12 2.12 0 0 1 0-2.164C2.325 5.316 4.49 2.5 8.085 2.5s5.76 2.816 6.702 4.418a2.12 2.12 0 0 1 0 2.164c-.941 1.602-3.107 4.418-6.702 4.418s-5.76-2.816-6.701-4.418m6.183.826c-1.08-.285-1.71-1.373-1.424-2.42a.496.496 0 0 0-.353-.611.504.504 0 0 0-.614.355c-.433 1.592.527 3.218 2.128 3.641s3.258-.512 3.691-2.105c.434-1.592-.527-3.218-2.128-3.641a3.04 3.04 0 0 0-1.557 0 .498.498 0 1 0 .252.965c.33-.088.687-.094 1.042 0 1.08.285 1.71 1.373 1.425 2.421-.286 1.048-1.383 1.68-2.462 1.395"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconEye16);
